import React from 'react';
import styled from 'styled-components';
import TextLink from '../TextLink';
import regionConfig from '../../../config';

const StyledFooter = styled.footer`
    display: flex;
    position: fixed;
    width: 100%;
    bottom: 0;
    justify-content: space-between;
    background-color: transperent;
    color: white;
    padding: 0.375rem 1rem;
    font-size: 16px;
    font-weight: 600;
    color: var(--black-60, rgba(17, 17, 17, 0.6));
    .company-name {
        color: #4ca65e;
        margin-right: 0.25rem;
    }
    .copyright-year {
        //margin-right: 0.25rem;
    }
    .user-agreement {
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        cursor: 'pointer';
    }
`;

const currentYear = new Date().getFullYear();
const copyRightYear = `©${currentYear} `;

const copyRightMessage = `| v${process.env.REACT_APP_VERSION}`;

const Footer = () => {
    const handleWebsiteClick = () => {
        window.open(`${regionConfig.webSiteUrl}`, '_blank');
    };

    return (
        <StyledFooter>
            <span className="company-name" onClick={handleWebsiteClick}>
                <TextLink color="primary">
                    <img src={regionConfig.FooterLogo} alt="convo footer" />
                </TextLink>
            </span>

            <div>
                <span className="copyright-year">{copyRightYear}</span>
                <span className="copyright-message">{copyRightMessage}</span>
            </div>
        </StyledFooter>
    );
};

export default Footer;
